import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionsDisplayGridRowDataFragmentGql } from './VirtualConnectionsDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!,
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        upstreamVirtualConnectionsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...VirtualConnectionsDisplayGridRowDataFragment
          }
        }
        maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
          orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection { totalCount }
          }
        }
        maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
          orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection { totalCount }
          }
        }
      }
    }
  }
}
${VirtualConnectionsDisplayGridRowDataFragmentGql}
`;
